export default class Controller {

    static get $inject() {
        return [
            '$state', 'ApiPanelsService', 'ApiRemoteService', '$rootScope', 'CookiesService', 'gettext', 'LanguageService',
            'ModalDialogService', '$element', '$scope', 'ApiAccountService', '$stateParams', 'UiHelper', 'UserCodeService'
        ];
    }

    constructor($state, ApiPanelsService, ApiRemoteService, $rootScope, CookiesService, gettext, LanguageService,
                ModalDialogService, $element, $scope, ApiAccountService, $stateParams, UiHelper, UserCodeService) {

        // View
        this.$rootScope = $rootScope;
        this._CookiesService = CookiesService;
        this.ApiPanelsService = ApiPanelsService;
        this.ApiRemoteService = ApiRemoteService;
        this.ApiAccountService = ApiAccountService;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.UiHelper = UiHelper;
        this.currentPage = 1;
        this.totalItems = 0;
        this.searchText = '';
        this.statuses = {online: gettext('online'), busy: gettext('busy'), offline: gettext('offline')};
        this.LanguageService = LanguageService;
        this.UserCodeService = UserCodeService;
        this.UserCodeService.deleteUserCode();
        ModalDialogService.setInactive();

        $scope.dontSref = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };

        this.registerToPanelDeleteIndicationModalCloseEvent();
        this.ApiPanelsService.resetHttpHeaders();

        $element.on('$destroy', () => {
            this.UiHelper.closeModals();
        });

    }

    registerToPanelDeleteIndicationModalCloseEvent() {

        $('#panelDeleteIndicationModal').on('hidden.bs.modal', () => {
            this.$state.reload();
        })
    }

    showDeletePanelYesNoModalAndSetGoingToDeletePanelId(panelObject) {

        this.goingToDeletePanelId = panelObject.control_panel.id;
        this.goingToDeletePanelName = panelObject.name;
        this._showDeletePanelYesNoModal();
    }

    deleteCurrentPanel() {

        this.ApiRemoteService.deletePanelFromAccount(this.goingToDeletePanelId).then(r => {
            this.isDeleteSuccsess = true;
        }).catch(err => {
            this.isDeleteSuccsess = false;
            this.errMessage = 'An error has occurred, can not delete control panel';
            if (hasOwnProperty.call(err.data, 'detail')) {
                this.errMessage = err.data.detail
            }
        }).finally(r => {
            this._showPanelDeleteIndicationModal();
        })
    }

    _showDeletePanelYesNoModal() {
        this.showModal('deletePanelYesNoModal');
    }

    _showPanelDeleteIndicationModal() {
        this.showModal('panelDeleteIndicationModal');
    }

    closeModal(modalName) {
        this.UiHelper.closeModal(modalName);
    }

    showModal(modalName) {
        this.UiHelper.showModal(modalName);
    }

    $onInit() {
        this.loadPanels(true);
    }

    pageChanged() {
        this.loadPanels();
    }

    loadPanels(onInit = false) {
        this.loading = true;
        this.ApiPanelsService.panels(this.currentPage, this.searchText)
            .then((r) => {
                this.totalItems = r.count;
                this.panels = r.results;
            })
            .finally((err) => {
                this.loading = false;

                if (onInit && this.panels) {

                    let panelsSize = this.perPage = this.panels.length;

                    //Navigate to panel dashboard page if there is only one panel.
                    if ((panelsSize == 1) && (this.$stateParams.redirect > 0)) {
                        let panelId = this.panels[0].id;
                        this.$state.go('main.panel.control', {id: panelId});
                    }
                    this.ApiPanelsService.setPanelsCounter(panelsSize);
                }
            });
    }

    getStateClass(stateFull, pairType) {

        if (this.isPanelConnected(stateFull, pairType)) {

            return this.statuses['online'];

        } else if (this.isPanelBusy(stateFull, pairType)) {

            return this.statuses['busy'];

        } else {

            return this.statuses['offline'];
        }
    }

    getStateClassTranslate(stateFull, pairType) {
        return this.LanguageService.getTranslatableText(this.getStateClass(stateFull, pairType));
    }

    isPanelConnected(stateFull, pairType) {

        let isStateFull = stateFull == 1 || stateFull == 2;
        let isPaired = pairType == null || pairType == 2;

        return isPaired && isStateFull;
    }

    isPanelBusy(stateFull, pairType) {

        let isStateFull = stateFull == 2;
        let isPaired = pairType == 1;

        return isPaired && isStateFull;
    }

    setCurrentPageCookie(panelId) {

        if (this._CookiesService.getCookie('currentPanel') != panelId) {

            this._CookiesService.setCookie('currentPage', 0);
            this._CookiesService.setCookie('currentPanel', panelId);
        }
    }

    refreshPage() {

        this.$state.reload();
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/controller.js
 **/